// components/TagMediaModal.jsx
import React, { useState, useEffect } from 'react';
import { X, Video, Image as ImageIcon } from 'lucide-react';
import { getToken } from "../api/utils";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const TagMediaModal = ({ tag, mediaFiles, onClose, onRefresh }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load existing permissions for this tag
  useEffect(() => {
    const fetchExisting = async () => {
      try {
        const res = await fetch(`${API_URL}/guests/tags/${tag.id}/media`, {
          headers: { Authorization: `Bearer ${getToken()}` }
        });
        if (res.ok) {
          const ids = await res.json();
          setSelectedIds(ids);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchExisting();
  }, [tag.id]);

  const handleSave = async () => {
    const res = await fetch(`${API_URL}/guests/tags/${tag.id}/media-sync`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json", 
        Authorization: `Bearer ${getToken()}` 
      },
      body: JSON.stringify({ ids: selectedIds }),
    });
    if (res.ok) {
      onRefresh(); // Re-fetch guests in parent
      onClose();
    }
  };

  if (loading) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-[40px] w-full max-w-xl overflow-hidden shadow-2xl">
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-xl font-black uppercase tracking-tight">Access for #{tag.name}</h2>
          <button onClick={onClose}><X /></button>
        </div>
        
        <div className="p-6 max-h-[60vh] overflow-y-auto space-y-2">
          {mediaFiles.filter(m => !(m.media_type === 'user_public'))
          .map(m => (
            <label key={m.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl cursor-pointer hover:bg-pink-50 transition-all">
              <div className="flex gap-3 items-center font-bold">
                 {m.file_type?.includes('video') ? <Video size={16}/> : <ImageIcon size={16}/>}
                 {m.name}
              </div>
              <input 
                type="checkbox" 
                checked={selectedIds.includes(m.id)}
                onChange={() => setSelectedIds(prev => 
                  prev.includes(m.id) ? prev.filter(id => id !== m.id) : [...prev, m.id]
                )}
                className="w-5 h-5 accent-[#ff0099]"
              />
            </label>
          ))}
        </div>

        <div className="p-6">
          <button onClick={handleSave} className="w-full py-4 bg-black text-white rounded-2xl font-bold">
            Update Group Permissions
          </button>
        </div>
      </div>
    </div>
  );
};

// export default TagMediaModal;